module.exports = __webpack_public_path__ + "static/media/dwgpdf.01d42756.png";